export function get_obj(global, param) {
    let wvobj = global.wv;
    if (wvobj) {
        let ret = wvobj[param];
        return ret;
    }

    return null;
}

export function set_obj(global, param, value) {
    let wvobj = global.wv;

    if (!wvobj) {
        wvobj = {};
        global.wv = wvobj;
    }

    wvobj[param] = value;
}
